import { isNil } from 'es-toolkit';
export function isNilOrEmptyString(value) {
    return isNil(value) || value === '';
}
